import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const SERVICE_PROVIDER_UNIT_PARAM = 'spuid';
export const CONTENT_TYPE_ID_PARAM = 'contenttypeid';

/**
 * Hook to extract the service provider unit ID (spuId) from the URL query parameters
 * @returns The spuId from the URL or undefined if not present
 */
export function useSpuIdFromUrl(): string | undefined {
  const { search } = useLocation();

  const spuId = useMemo(() => {
    const searchParams = new URLSearchParams(search);
    const target = SERVICE_PROVIDER_UNIT_PARAM.toLowerCase();

    for (const [key, value] of searchParams.entries()) {
      if (key.toLowerCase() === target) {
        return value;
      }
    }

    return undefined;
  }, [search]);

  return spuId;
}

/**
 * Hook to extract the content type ID from the URL query parameters.
 * Used by the diary-note wizard to pre-select a note type when launched from a calendar event.
 * @returns The contenttypeid from the URL or undefined if not present
 */
export function useContentTypeIdFromUrl(): string | undefined {
  const { search } = useLocation();

  const contentTypeId = useMemo(() => {
    const searchParams = new URLSearchParams(search);
    const target = CONTENT_TYPE_ID_PARAM.toLowerCase();

    for (const [key, value] of searchParams.entries()) {
      if (key.toLowerCase() === target) {
        return value;
      }
    }

    return undefined;
  }, [search]);

  return contentTypeId;
}
